var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlertIcon = function SvgAlertIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.12 15.17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e03030;}.cls-3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3008",
    className: "cls-3",
    d: "M0,.91H13.35V14.26H0V.91Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "filters-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.06,
    cy: 7.58,
    r: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.06,.78h0c-3.76,0-6.81,3.05-6.81,6.81,0,3.76,3.05,6.81,6.81,6.81,3.76,0,6.81-3.05,6.81-6.81,0-3.76-3.05-6.81-6.81-6.81Zm-.03,3.01s0,0,.01,0c.31,0,.57,.24,.57,.55,0,0,0,.02,0,.02l-.11,3.77c0,.26-.19,.48-.45,.48,0,0,0,0,0,0-.26,0-.47-.22-.46-.47,0,0,0,0,0,0l-.11-3.77c0-.31,.24-.57,.55-.58Zm.03,7s0,0,0,0h0c-.33-.01-.59-.29-.58-.62,.01-.33,.29-.59,.62-.58,.32,.01,.58,.28,.58,.6,0,.34-.28,.61-.62,.6Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "alert-icon.2cf2951ef6bd87037238c72d5bf10dd3.svg";